module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1143.c5c5c92b.png";